const isBase64ImageValue = (value: string): boolean =>
  value.trim().startsWith("data:image");

const isHttpImageUrl = (value: string): boolean =>
  /^https?:\/\//i.test(value.trim());

/** Presigned / full URLs → filename only; new uploads (base64) → unchanged. */
export const extractImageFileNameFromUrl = (url: string): string => {
  try {
    const fileName = new URL(url.trim()).pathname
      .split("/")
      .filter(Boolean)
      .pop();
    return fileName ?? url.trim();
  } catch {
    return url.trim();
  }
};

/**
 * New uploads (base64 data URL) are sent as-is.
 * Existing loaded image URLs become filename only (same as notification update).
 */
export const resolveImageUrlForApi = (imageUrl: string): string => {
  const trimmed = imageUrl?.trim() ?? "";
  if (!trimmed) {
    return "";
  }
  if (isBase64ImageValue(trimmed)) {
    return trimmed;
  }
  if (isHttpImageUrl(trimmed)) {
    return extractImageFileNameFromUrl(trimmed);
  }
  return trimmed;
};

export const resolveImageListForApi = (
  images: string[] | undefined | null
): string[] => {
  if (!Array.isArray(images)) {
    return [];
  }
  return images.map(resolveImageUrlForApi);
};
